import React from 'react';
import { UnscheduledEvent } from '../../types';

/**
 * Props for {@link ModalHeaderAliases}.
 */
interface ModalHeaderAliasesProps {
  formData: UnscheduledEvent;
}

/**
 * Renders the read-only audit-alias trio (Created / Last Edited / Completed By)
 * shown in the event modal header.
 */
const ModalHeaderAliases: React.FC<ModalHeaderAliasesProps> = ({ formData }) => {
  return (
    <div className="modal-header-aliases">
      <div className="field-input-block">
        <span className="field-input-label">Created By</span>
        <input
          type="text"
          value={formData.createdByAlias || '—'}
          readOnly
          disabled
          className="field-input alias-field"
        />
      </div>
      <div className="field-input-block">
        <span className="field-input-label">Last Edited By</span>
        <input
          type="text"
          value={formData.lastEditedByAlias || '—'}
          readOnly
          disabled
          className="field-input alias-field"
        />
      </div>
      <div className="field-input-block">
        <span className="field-input-label">Completed By</span>
        <input
          type="text"
          value={formData.completedByAlias || '—'}
          readOnly
          disabled
          className="field-input alias-field"
        />
      </div>
    </div>
  );
};

export default ModalHeaderAliases;
